import React from 'react';
import { useTranslation } from 'react-i18next';
import { CustomTextField } from '../../../../../../../../components/CustomTextField';
import { CustomSwitch } from '../../../../../../../../components/CustomSwitch';
import CustomAddChipSearch from '../../../../../../../../components/CustomAddChipSearch';
import {departmentListToLabel} from '../../../../../../../../Apis/functions';
import { TABLES } from '../../../../../../../../Apis/Tables';
import {IconDepartment} from "../../../../../../../../components/buttons/IconButtons";
import {SERVICE_ADVANCED_SEARCH} from "../../../../../../../../reduxToolkit/Commons/CommonsApi";
import {POSITION_MODEL} from "../../../../../../../../Helpers/PositionModel";
import {CustomSelect} from "../../../../../../../../components/CustomSelect";
import {
    CONFLICT_RESOLUTION_LIST,
    CONFLICT_RESOLUTION_MODEL,
    STACK_METHOD_LIST
} from "../Model/Model";
import {useSelector} from "react-redux";
/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 */
const PolicyDetails = ({
    item,
    setItem,
    handleChange,
    emptyFields,
    selectedList,
    setSelectedList,
    showInheritedConfigLegend = false,
    cleanChipSearch,
    setCleanChipSearch,
    disabled
}) => {
    const { t } = useTranslation();
    const {getOvertimePolicyGroupConfig} = useSelector((state) => state?.PayrollPolicySlice);

    // The inherited legend only shows while the field still matches the system
    // configured value; once a different value is chosen it is hidden.
    const inheritedLegend = (field, value) =>
        showInheritedConfigLegend && getOvertimePolicyGroupConfig?.[field] != null && value === getOvertimePolicyGroupConfig[field]
            ? t('inherited_payroll_config_legend')
            : undefined;

    return (
        <div className='row'>
            <div className='col-12 px-0'>
                <CustomTextField
                    id='txt_pd_name'
                    name='name'
                    value={item?.name}
                    trans='name'
                    type='text'
                    required={true}
                    emptyFields={emptyFields}
                    length={128}
                    onChange={handleChange}
                    disabled={disabled}
                />
            </div>

            <div className='col-sm-12 col-md-4 px-0 input-padding-bottom'>
                <CustomSwitch
                    id='cs_pd_is_global'
                    name='isGlobal'
                    trans='is_global'
                    checked={item?.isGlobal}
                    showBorder={true}
                    onChange={(e) => setItem((prev) => ({ ...prev, isGlobal: e.target.checked }))}
                    disabled={true}
                />
            </div>

            {!item?.isGlobal && (
                <>
                    <div className='col-12 px-0'>
                        <CustomAddChipSearch
                            autocompleteId={'slt_pd_departments'}
                            buttonId={'btn_pd_departments'}
                            selectedList={selectedList}
                            setSelectedList={setSelectedList}
                            disabled={disabled}
                            label="departments"
                            emptyFields={emptyFields}
                            required={true}
                            reset={false}
                            hideButton={false}
                            keyId={"id"}
                            showSubSection={false}
                            showRenderOption={true}
                            maxLength={99}
                            sanitizeDataList={departmentListToLabel}
                            Icon={IconDepartment}
                            chipIcon={IconDepartment}
                            cleanChipSearch={cleanChipSearch}
                            setCleanChipSearch={setCleanChipSearch}
                            placeholder={t("select_one_or_more_departments")}
                            api={SERVICE_ADVANCED_SEARCH}
                            model={TABLES.PAYROLL_POLICY_GROUP_AVAILABLE_DEPARTMENT}
                            positionIconOptions={POSITION_MODEL.LEFT}
                        />
                    </div>
                    <div className='col-12 px-0'>
                        <CustomSelect
                            id={'slt_pd_conflict_resolution'}
                            name={'conflictResolution'}
                            value={item.conflictResolution}
                            keyName='id'
                            onChange={handleChange}
                            list={CONFLICT_RESOLUTION_LIST()}
                            trans={'conflict_resolution'}
                            label={'slt_af_module'}
                            emptyFields={emptyFields}
                            required={true}
                            showNoSelectionOption={false}
                            helperText={inheritedLegend("conflictResolution", item.conflictResolution)}
                            disabled={disabled}
                        />
                    </div>

                    { item.conflictResolution === CONFLICT_RESOLUTION_MODEL.STACKABLE &&
                    <div className='col-12 px-0'>
                        <CustomSelect
                            id={'slt_pd_stack_method'}
                            name={'stackMethod'}
                            value={item.stackMethod}
                            keyName='id'
                            onChange={handleChange}
                            list={STACK_METHOD_LIST()}
                            trans={'stack_method'}
                            label={'slt_pd_stack_method'}
                            emptyFields={emptyFields}
                            required={true}
                            showNoSelectionOption={false}
                            helperText={inheritedLegend("stackMethod", item.stackMethod)}
                            disabled={disabled}
                        />
                    </div>
                    }
                </>
            )}
        </div>
    );
};

export default PolicyDetails;
